import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { RequestPayload } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { CampaignConfigService } from "./campaign.config";
import { Campaign, Offer, OfferState } from "./campaign.model";

@Injectable({
	providedIn: "root",
})
export class CampaignService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: CampaignConfigService
	) {}

	getOffer(offerId: string): Observable<Offer> {
		return this.httpClient.get<Offer>({
			url: this.config.getEndpointOffer(),
			searchParams: { offerId },
		});
	}

	getOffers(state?: OfferState): Observable<Offer[]> {
		const payload: RequestPayload = {
			url: this.config.getEndpointOffers(),
		};

		if (state) {
			payload.searchParams = { state };
		}

		return this.httpClient.get<Offer[]>(payload);
	}

	enrollToOffer(offerId: string): Observable<object> {
		return this.httpClient.post({
			url: this.config.getEndpointOfferEnrollments(),
			searchParams: { offerId },
		});
	}

	enrollToCampaign(campaign: Campaign): Observable<object> {
		const { isJoinWithCode, campaignCode } = campaign;
		return this.httpClient.post({
			url: isJoinWithCode
				? this.config.getEndpointCampaignEnrollments()
				: this.config.getEndpointOptInCampaignEnrollments(),
			searchParams: { campaignCode },
		});
	}
}
